import React from "react";
import { Report } from "./report";
import styles from "./styles.scss";

function Loader() {
  return (
    <ul className={styles.reportsList}>
      <li className={styles.report}>
        <Report />
      </li>
      <li className={styles.report}>
        <Report />
      </li>
      <li className={styles.report}>
        <Report />
      </li>
      <li className={styles.report}>
        <Report />
      </li>
      <li className={styles.report}>
        <Report />
      </li>
      <li className={styles.report}>
        <Report />
      </li>
    </ul>
  );
}

export { Loader };
